import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { useAuthStore } from '../context/store';
import { FiHome, FiLogOut, FiUser, FiSettings } from 'react-icons/fi';
import { getBrand } from '../utils/brand';

export default function Layout() {
  const { user, logout } = useAuthStore();
  const location = useLocation();
  const brand = getBrand(user?.brand);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top Navigation */}
      <nav className="bg-primary-900 text-white shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center space-x-3">
              <span className="text-xl font-bold">{brand.icon} {brand.name}</span>
              <span className="text-sm text-primary-200">Booking Manager</span>
            </Link>
            <div className="flex items-center space-x-4">
              {user?.role === 'superadmin' && (
                <Link to="/admin" className="text-sm bg-brand-orange text-primary-900 px-3 py-1 rounded hover:bg-yellow-400 transition font-medium">
                  <FiSettings className="inline mr-1" /> Admin Panel
                </Link>
              )}
              <span className="text-sm text-primary-200">
                <FiUser className="inline mr-1" />{user?.name}
              </span>
              <button onClick={() => { logout(); window.location.href = '/login'; }} className="text-sm hover:text-red-300 transition">
                <FiLogOut className="inline mr-1" /> Logout
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Breadcrumb */}
      {location.pathname !== '/' && (
        <div className="max-w-7xl mx-auto px-4 py-2">
          <Link to="/" className="text-sm text-primary-600 hover:underline">
            <FiHome className="inline mr-1" /> Home
          </Link>
          <span className="text-gray-400 mx-2">/</span>
          <span className="text-sm text-gray-600 capitalize">
            {location.pathname.slice(1).replace(/-/g, ' ')}
          </span>
        </div>
      )}

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <Outlet />
      </main>
    </div>
  );
}
